import React from 'react';
import { Button, Container, Image, Stack } from 'react-bootstrap';
import { IMAGE_PATHS } from 'constants/imagePaths';
import parse from 'html-react-parser';
import useTranslate from 'hooks/useTranslate';
import { useNavigate } from 'react-router-dom';
import { USER_TYPES } from 'constants';
import './styles.scss';

const ForEmployees: React.FC = () => {
	const { translate } = useTranslate();
	const navigate = useNavigate();

	return (
		<section className="for-employees">
			<Container>
				<div className="d-flex flex-column flex-lg-row gap-3 gap-md-4">
					<div className="for-employees-card text-center flex-1">
						<Button
							onClick={() => navigate(`/signup?userType=${USER_TYPES.SEEKER}`)}
							className="filled-btn rounded-pill mx-auto"
						>
							{translate('Common.joinAsSeeker')}
						</Button>
						<div className="for-employees-img">
							<Image
								src={IMAGE_PATHS.ForEmployeesImg}
								className="w-auto"
								alt="employees-img"
								loading="lazy"
							/>
						</div>
						<Stack className="for-employees-content">
							{/* <h4 className="fw-bold mb-0">{parse(translate('Home.forEmployeesTitle'))}</h4> */}
							{parse(translate('Home.forEmployeesDescription'))}
						</Stack>
					</div>
					<div className="for-employees-card for-employer text-center flex-1">
						<Button
							onClick={() => navigate(`/signup?userType=${USER_TYPES.COMPANY}`)}
							className="filled-btn rounded-pill mx-auto"
						>
							{translate('Common.joinAsEmployer')}
						</Button>
						<div className="for-employees-img">
							<Image
								src={IMAGE_PATHS.ForEmployersImg}
								className="w-auto"
								alt="employees-img"
								loading="lazy"
							/>
						</div>
						<Stack className="for-employees-content">
							{/* <h4 className="fw-bold mb-0">{parse(translate('Home.forEmployersTitle'))}</h4> */}
							{parse(translate('Home.forEmployersDescription'))}
						</Stack>
					</div>
				</div>
			</Container>
		</section>
	);
};

export default ForEmployees;
